import dashboard from './dashboard.svg';
import notifications from './notifications.svg';
import settings from './settings.svg';
import notification from './notification.svg';
import mail from './mail.svg';
import logo from './image.png';
import components from './components.svg';
import tables from './tables.svg';
import typography from './typography.svg';

const icons = { 
  dashboard,
  notifications,
  logo,
  settings,
  notification,
  mail,
  components,
  tables,
  typography,
};

export default icons;